import { getConfig } from '@/config/config.ts';
import type { Person, PersonsRolesResponse } from '@/model/Person.ts';
import { createApi } from '@reduxjs/toolkit/query/react';
import { webApiResponseBaseQuery } from './webApiResponseBaseQuery.ts';
import type { LegalEntity } from '@/model/LegalEntity.ts';

export type SearchParams = {
  searchTerm: string;
  all?: boolean;
  entity: LegalEntity
};
const prefixUrl = getConfig().prefixUrl ?? '';

export const personApi = createApi({
  reducerPath: 'personApi',
  baseQuery: webApiResponseBaseQuery<unknown>,
  endpoints: (builder) => ({
    searchPersons: builder.query<Person[], SearchParams>({
      query: ({ searchTerm, all = false, entity }) => ({
        method: 'POST',
        url: `${prefixUrl}/persons`,
        body: { searchValue: searchTerm, all },
        params: {
          legalEntity: entity
        }
      }),
      keepUnusedDataFor: 30, // keep unused results for 30s in cache
      transformResponse: ({ data: persons }) => persons as Person[],
    }),
    PersonsRoles: builder.query<PersonsRolesResponse, {personId: string, entity: LegalEntity}>({
      query: ({personId, entity}) => ({
        method: 'GET',
        url: `${prefixUrl}/persons/roles`,
        params: {
          personKey: personId,
          legalEntity: entity
        }
      }),
      transformResponse: ({ data: personsRoles }) => personsRoles?.[0] as PersonsRolesResponse,
    }),
  }),
});

export const { useSearchPersonsQuery, useLazySearchPersonsQuery, usePersonsRolesQuery } = personApi;
